import React, { useState } from "react";

// Hooks
import { useSelector } from "react-redux";

// Components
import EditCustomFieldModal from "~/components/Settings/CustomFields/EditCustomFieldModal";
import DeleteModal from "~/components/Settings/CustomFields/DeleteModal";

// Utils
import { MESSAGES } from "~/utils/message";

// MUI Components
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Pagination,
  PaginationItem,
  Typography,
  Tooltip,
  Stack,
} from "@mui/material";

// Components
import Loader from "~/components/General/Loader";

// Icons
import { Edit4CIcon, DeleteCIcon, NoContactCIcon } from "~/assets/images";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// Styles
import "./styles.scss";

const CustomTable = ({
  pagination,
  updatePagination,
  setDeleteModal,
  setEditModal,
  setSelectedCustomField,
}) => {
  const [editCustomFieldModal, setEditCustomFieldModal] = useState(false);
  const [deleteCustomFieldModal, setDeleteCustomFieldModal] = useState(false);

  const rows =
    useSelector((state) => state.customFieldsReducers.customFields) || [];
  const to = useSelector((state) => state.customFieldsReducers.to);
  const from = useSelector((state) => state.customFieldsReducers.from);
  const lastPage = useSelector(
    (state) => state.customFieldsReducers.lastPage || 1
  );
  const currentPage = useSelector(
    (state) => state.customFieldsReducers.currentPage || 1
  );

  const isLoading = useSelector((state) => state.customFieldsReducers.loading);
  const loaded =
    useSelector((state) => state.customFieldsReducers.customFields) || [];

  const rowsCount =
    useSelector((state) => state.customFieldsReducers.rowsCount) || 0;

  const sortedRows =
    [...rows].sort((a, b) => a?.value?.localeCompare(b?.value)) || [];

  const handleChangePage = (event, newPage) => {
    updatePagination({
      page: newPage,
      pageSize: pagination.pageSize,
    });
  };
  const handleDelete = (row) => {
    setSelectedCustomField(row);
    setDeleteModal(true);
  };
  const handleEdit = (row) => {
    setSelectedCustomField(row);
    setTimeout(() => {
      setEditModal(true);
    }, 10);
  };

  const columns = [
    {
      field: "value",
      headerName: "Custom Field Name",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box className="addressWrapper">
            <Typography>{params.row.value}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box className="webhookTableActions">
            <Tooltip title="Edit">
              <img
                src={Edit4CIcon}
                height={20}
                alt="Edit"
                onClick={() => handleEdit(params.row)}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <img
                src={DeleteCIcon}
                alt="delete"
                onClick={() => handleDelete(params.row)}
              />
            </Tooltip>
          </Box>
        </>
      ),
    },
  ];

  return (
    <div
      style={{
        marginTop: "25px",
        width: "100%",
      }}
      className="customTableWrapper"
    >
      <DataGrid
        rows={sortedRows}
        columns={columns}
        loading={isLoading}
        pageSizeOptions={[20, 50, 100]}
        rowCount={rowsCount || 0}
        pagination={pagination}
        paginationMode="server"
        className="customTableGrid"
        hideFooterSelectedRowCount
        hideFooterPagination
        rowSelection={false}
        getRowId={(row) => row.id}
        disableColumnMenu={true}
        slots={{
          noRowsOverlay: () => (
            <Stack className="noRowsTextContacts">
              <img src={NoContactCIcon} alt="NoContact" />
              {MESSAGES.NO_ROWS_TEXT}
            </Stack>
          ),
          noResultsOverlay: () => (
            <Stack className="noRowsTextContacts">
              <img src={NoContactCIcon} alt="NoContact" />
              {MESSAGES.NO_ROWS_TEXT}
            </Stack>
          ),
          loadingOverlay: Loader,
        }}
      />
      <Box className="paginationWrapper">
        <Pagination
          count={lastPage}
          variant="outlined"
          shape="rounded"
          onChange={handleChangePage}
          page={currentPage}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                previous: ArrowBackIosNewIcon,
                next: ArrowForwardIosIcon,
              }}
              {...item}
            />
          )}
        />
        <Typography>
          Showing {rowsCount ? from : 0} to{" "}
          {rowsCount < to ? rows?.length + from - 1 : to} of {rowsCount} results
        </Typography>
      </Box>
      <EditCustomFieldModal
        openModal={editCustomFieldModal}
        handleCloseModal={() => setEditCustomFieldModal(false)}
      />
      <DeleteModal
        openModal={deleteCustomFieldModal}
        handleCloseModal={() => setDeleteCustomFieldModal(false)}
      />
    </div>
  );
};

export default CustomTable;
